// export const url = 'http://localhost:5000'
export const url = 'https://ece692-nlp.herokuapp.com'
